// extracted by mini-css-extract-plugin
module.exports = {"Pagination":"Pagination_Pagination__2g2_F","Counter":"Pagination_Counter__Uev9x"};